import { Injectable } from '@angular/core';
import { ApiServiceService } from '../../../services/api-service.service';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthAPIService {

  constructor(private _apiService: ApiServiceService) { }



  ForgetPassword(model: any) {
    return this._apiService.post(`${environment.apiUrl}/forget-password`, model)
      .pipe(catchError(this.handleError));
  }

  ResetPassword(model: any, Token: string) {
    return this._apiService.post(`${environment.apiUrl}/reset-password/${Token}`, model)
      .pipe(catchError(this.handleError));
  }

  VerifyAccount(model: any, Token: string) {
    return this._apiService.post(`${environment.apiUrl}/verify-account/${Token}`, model)
      .pipe(catchError(this.handleError));
  }

  VerifyChanges(Token: string) {
    return this._apiService.post(`${environment.apiUrl}/verify-changes/${Token}`)
      .pipe(catchError(this.handleError));
  }

  CheckToken(Token:string){
    return this._apiService.post(`${environment.apiUrl}/check-token/${Token}`)
    .pipe(catchError(this.handleError));
  }

  RegisterVendor(model: any) {
    return this._apiService.post(`${environment.apiUrl}/register-vendors`, model)
      .pipe(catchError(this.handleError));
  }

  handleError(error: any) {
    return throwError(error);
  }


}
